import React, { useState } from 'react'
import CommentBox from '../../common/CommentBox'
import message from "../../../assets/img/icons/messages.svg"
import Button from '../../shared/Button'
import CommentModal from './CommentModal'
import CommentBoxModal from './CommentBoxModal'
const PlaceComment = ({inforesidencedetail}) => {
  const [ReplyModal, setReplyModal] = useState(false)
  const [ShowCommentModa, setShowCommentModa] = useState(false)
  console.log(inforesidencedetail)
  return (
    <div className='PlaceComment'>
      <div className='flex justify-between items-center '>
        <h2 className='text-[#292D32] text-[32px] font-[900]'>دیدگاه ها ونظرات</h2>
        <Button varient="outlined" onClick={()=>setShowCommentModa(true)}>
          <div className='flex'>
            <img src={message} className='ml-[9px]'/>
            <div>افزودن دیدگاه</div>
          </div>
        </Button>
      </div>
      {inforesidencedetail && 
        inforesidencedetail?.comments.map(i=>
          <CommentBox info={i} />
          )
      }
  
    
      {
        ReplyModal && <ReplyModal closeModal={()=>setReplyModal(false)}/>
      }
        {
        ShowCommentModa && <CommentBoxModal inforesidencedetail={inforesidencedetail} closeModal={()=>setShowCommentModa(false)}/>
      }
    </div>
  )
}

export default PlaceComment